export default __webpack_public_path__ + "static/media/MATIC.67b7fd4c.svg";